<template>
  <Main>
    <ToolsPanel :breadCrumbFirst="$t('nav.blockedCountries')" :title="$t('nav.blockedCountries')">
      <div class="list__buttons">
        <MainButton @click.native="handleAddModal()">Add Country</MainButton>
      </div>
    </ToolsPanel>
    <ContentContainer>
      <div class="list__filter">
        <div class="list__filter-item ids">
          <input type="text" v-model="filterData.client_name" placeholder="Name" />
        </div>

        <div class="list__filter-button">
          <MainButton @click.native="filterList()">Filter</MainButton>
        </div>
        <div class="list__filter-button">
          <MainButton @click.native="filterListReset()">Reset</MainButton>
        </div>
      </div>

      <div class="list">
        <div v-if="itemsList.length">
          <CustomTable
            v-if="itemsList.length"
            :data="itemsList"
            :deleted-keys="tableOptions.deletedKeys"
            :rename-columns="tableOptions.renameColumn"
            :custom-order="tableOptions.customOrder"
            :is-action-block-visible="tableOptions.isActionBlockVisible"
            :handle-delete="handleDelete"
            :handleFilter="handleFilter"
            :direction="directionSort"
            :order="orderSort"
            :noSortColumn="tableOptions.noSortColumn"
            :name="'clients'"
          >
          </CustomTable>
          <!-- <div class="pagination">
            <Pagination
              :maxPage="items.lastPage"
              :page="page"
              :urlList="'COUNTRY_LIST'"
              :totalItem="items.total"
            />
          </div> -->
        </div>
        <div class="list__no-have" v-else>No country found by this parameter.</div>
      </div>
    </ContentContainer>

    <ModalError
      :error-modal="false"
      :handle-close-error-modal="
        () => {
          this.error = {};
        }
      "
    />

    <MainModal v-if="addModal" :on-close="handleCloseConfirmModal" :modal-center="true">
      <div class="list__confirm">
        <div class="list__confirm-title">Add Country</div>
        <div class="list__confirm-form">
          <div class="list__filter-item">
            <div class="check-selector">
              <div
                @click="resetCheck([])"
                v-if="exclude_country.length > 0"
                class="check-selector__reset"
              >
                <svg
                  data-v-6ab518a4=""
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  height="20px"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g data-v-6ab518a4="" id="Menu / Close_MD">
                    <path
                      data-v-6ab518a4=""
                      id="Vector"
                      d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                      stroke="#000000"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </g>
                </svg>
              </div>
              <div class="check-selector__button">
                <div class="check-selector__button-name">
                  <template v-if="exclude_country.length > 0">
                    {{ exclude_country[0].en_name }}

                    <template v-if="exclude_country.length > 1">
                      +{{ exclude_country.length - 1 }}
                    </template>
                  </template>
                  <template v-else> Exclude Country </template>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                  <path
                    d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                  ></path>
                </svg>
              </div>

              <div class="check-selector__list">
                <div class="check-selector__list-container">
                  <div class="check-selector__search">
                    <input v-model="search_exclude_country" placeholder="Search Country" />
                  </div>
                  <div class="check-selector__check-items">
                    <div
                      v-for="item in exclude_country"
                      :key="item.id"
                      class="check-selector__check-item"
                      @click="removeCheckElement(item)"
                    >
                      {{ item.en_name }} <span>-</span>
                    </div>
                  </div>
                  <div
                    @click="addCheckElement(item)"
                    v-for="item in getCheckList('items', 'search_exclude_country', 'en_name')"
                    :key="item.id"
                    class="check-selector__list-item"
                  >
                    {{ item.en_name }} <span>+</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="list__confirm-buttons">
          <div class="list__confirm-button">
            <MainButton buttonWhite @click.native="handleCloseConfirmModal">CANCEL</MainButton>
          </div>
          <div class="list__confirm-button">
            <MainButton @click.native="handleAddCountry" :button-cancel="true">ADD</MainButton>
          </div>
        </div>
      </div>
    </MainModal>

    <MainModal v-if="deleteModal" :on-close="handleCloseConfirmModal" :modal-center="true">
      <div class="list__confirm">
        <div class="list__confirm-title">Delete Country</div>

        <div class="list__confirm-buttons">
          <div class="list__confirm-button">
            <MainButton buttonWhite @click.native="handleCloseConfirmModal">CANCEL</MainButton>
          </div>
          <div class="list__confirm-button">
            <MainButton @click.native="handleDeleteRow" :button-cancel="true">ADD</MainButton>
          </div>
        </div>
      </div>
    </MainModal>

    <MainModal v-if="deleteModalSuccess" :on-close="handleCloseSuccessModal">
      <div class="list__success-delete">Client {{ deleteRow.name }} successfully deleted.</div>
    </MainModal>
    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import leadApi from "~/api/lead";
import moment from "moment";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import CustomTable from "~/components/molecules/CustomTable.vue";
import Pagination from "~/components/molecules/Pagination.vue";
import MainModal from "~/components/molecules/MainModal.vue";
import ModalError from "~/components/molecules/ModalError.vue";

export default {
  name: "CountryList",
  metaInfo() {
    return {
      title: this.$t("nav.blockedCountries"),
    };
  },
  data() {
    return {
      items: {},
      itemsList: [],
      errorField: {},

      exclude_country: [],
      search_exclude_country: "",

      addModal: false,

      logsModal: false,
      logsModalArray: [],
      deleteModal: false,
      deleteRow: null,
      deleteModalSuccess: false,
      directionSort: false,
      orderSort: "id",

      detailModal: false,
      chosenLead: null,

      filterData: {
        client_name: "",
      },
      isFilter: false,

      tableOptions: {
        deletedKeys: ["null"],
        noSortColumn: ["integrations_count", "integrations_active"],
        isActionBlockVisible: true,
        renameColumn: [
          {
            from: "id",
            to: "ID",
          },
          {
            from: "en_name",
            to: "Name",
          },
        ],
        customOrder: ["id", "en_name", "null"],
      },
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    CustomTable,
    // Pagination,
    MainModal,
    ModalError,
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onKeyDown);
  },
  mounted() {
    window.addEventListener("keydown", this.onKeyDown);
    this.getList();
  },
  watch: {
    $route(to, from) {
      this.getList();
    },
  },
  computed: {
    ...mapState("lead", ["error", "loadingProcess"]),
    page() {
      return +this.$route.params.page;
    },
  },
  methods: {
    onKeyDown(e) {
      if (e.key === "Enter") {
        this.filterList();
      }
    },
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm");
    },
    getList() {
      let url = `/all?page=${this.page}&perPage=300`;
      if (this.orderSort.length) {
        url = url + `&sortField=${this.orderSort}&sortDest=${this.directionSort ? "asc" : "desc"}`;
      }

      if (this.isFilter) {
        if (this.filterData.client_name.length) {
          url += `&en_name=${this.filterData.client_name}`;
        }
      }

      leadApi
        .getCountryListDisable(url)
        .then((res) => {
          this.$store.commit("lead/setLoading", false);
          const i = res.data.items;
          this.items = i;

          this.itemsList = [];

          i.forEach((el, index) => {
            if (el.is_forbidden_lead == 1) {
              this.itemsList.push(el);
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit("lead/setLoading", false);
          this.isFilter = false;
        });
    },

    filterList() {
      this.isFilter = true;
      if (this.page > 1) {
        this.$router.push({
          path: ROUTE.COUNTRY_LIST.replace(":page", 1),
        });
      } else {
        this.getList();
      }
    },
    filterListReset() {
      this.isFilter = false;
      this.getList();
      this.filterData.integration_name = "";
      this.filterData.client = null;
    },
    handleFilter(column) {
      this.orderSort = column;
      if (this.directionSort === null) {
        this.directionSort = true;
      } else {
        this.directionSort = !this.directionSort;
      }
      this.getList();
    },
    handleAddModal() {
      this.addModal = true;
    },
    handleDelete(row) {
      this.deleteModal = true;
      this.deleteRow = row;
    },
    handleEdit(row) {
      this.$router.push({
        path: ROUTE.CLIENT_EDIT.replace(":id", `${row.id}`),
      });
    },
    handleDetail(row) {
      this.detailModal = true;
      this.chosenLead = this.leadsList.find((item) => item.id === row.id);
    },
    handleCloseDetailModal() {
      this.detailModal = false;
      this.chosenLead = null;
    },
    handleCloseConfirmModal() {
      this.deleteModal = false;
      this.addModal = false;
      this.exclude_country = [];
      this.search_exclude_country = "";
    },
    handleDeleteRow() {
      const url = `/${this.deleteRow.id}`;

      leadApi
        .getItemCountry(url)
        .then((res) => {
          this.$store.commit("lead/setLoading", false);
          const data = res.data;
          data.is_forbidden_lead = 0;
          data.iso3_code = data.iso_3_code;

          leadApi
            .editCountry(url, data)
            .then((res) => {
              this.$store.commit("lead/setLoading", false);
              this.handleCloseConfirmModal();
              this.getList();
            })
            .catch((error) => {
              console.log(error);
              this.$store.commit("lead/setLoading", false);
            });
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit("lead/setLoading", false);
        });
    },
    handleCloseSuccessModal() {
      this.deleteModalSuccess = false;
    },
    closeModal() {
      this.error = null;
    },
    handleAddCountry() {
      if (this.exclude_country.length > 0) {
        this.exclude_country.forEach((el) => {
          const url = `/${el.id}`;
          const data = el;
          data.is_forbidden_lead = 1;
          data.iso3_code = data.iso_3_code;
          leadApi
            .editCountry(url, data)
            .then((res) => {
              this.$store.commit("lead/setLoading", false);
              this.handleCloseConfirmModal();
              this.getList();
            })
            .catch((error) => {
              console.log(error);
              this.$store.commit("lead/setLoading", false);
            });
        });
      }
    },

    resetCheck(reset) {
      this.exclude_country = reset;
    },
    removeCheckElement(value) {
      this.exclude_country = this.exclude_country.filter((obj) => obj.id !== value.id);
    },
    addCheckElement(value) {
      const foundObj = this.exclude_country.find((obj) => obj.id === value.id);
      if (foundObj == undefined) {
        this.exclude_country.push(value);
      }
    },
    getCheckList(listKey, filterKey, nameKey) {
      const arr = this?.[listKey];
      const rawFilter = this?.[filterKey];

      if (!Array.isArray(arr)) return [];

      if (rawFilter == null || String(rawFilter).trim() === "") return arr;

      const filterStr = String(rawFilter).toLowerCase().trim();

      return arr.filter((item) => {
        const val = item?.[nameKey];
        if (val == null) return false;

        return String(val).toLowerCase().includes(filterStr);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.custom-table__header,
/deep/.custom-table__row {
  grid-template-columns: 0.4fr 1fr 1fr !important;
}

.list {
  &__confirm-form {
    padding-top: 50px;
  }
  &__filter {
    padding: 10px 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  &__filter-item {
    width: 150px;
    margin-right: 10px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;

    &.id {
      width: 100px;
    }

    input {
      padding: 5px 10px;
      font-size: 14px;
      width: 100%;
      height: 40px;
    }
  }

  &__filter-button {
    width: 100px;
    margin-right: 10px;
    padding-bottom: 10px;
  }

  &__modal-log-detail-button {
    padding: 10px 0;
    font-weight: 700;
    cursor: pointer;
  }

  &__modal-log-detail {
    background: rgb(39, 39, 39);
    border-radius: 5px;
    padding: 10px;
    color: #fff;
    overflow-y: auto;
  }
}

.check-selector {
  position: relative;

  &__reset {
    position: absolute;
    left: 5px;
    cursor: pointer;
    top: 9px;
    z-index: 11;
  }

  &__list {
    display: none;
    position: absolute;
    top: calc(100% - 20px);
    left: -100px;
    min-width: calc(300px + 40px);
    max-width: 400px;
    max-height: 340px;
    z-index: 10;
    padding: 20px;
  }

  &__list-container {
    padding: 5px;
    border-radius: 5px;
    border: 1px solid #3c2a1e;
    background: #fff;
    overflow-y: auto;
    max-height: 300px;
  }

  &__button {
    width: 370px;
    padding: 5px 5px 5px 30px;
    border: 1px solid #3c2a1e;
    border-radius: 5px;
    position: relative;
    height: 40px;
    display: flex;
    align-items: center;

    svg {
      margin-left: 10px;
    }
  }

  &__button-name {
    width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__list-item {
    padding: 5px 5px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    &:hover {
      background: #c7c3c0;
    }

    span {
      width: 20px;
      height: 20px;
      min-width: 20px;
      min-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #3c2a1e;
      font-size: 15px;
      font-weight: 700;
      color: #fff;
      border-radius: 50px;
      line-height: 1;
    }
  }

  &__check-items {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #3c2a1e;
    padding: 10px 0;
    margin-bottom: 10px;
  }

  &__check-item {
    padding: 5px;
    border-radius: 5px;
    background: #3c2a1e;
    color: #fff;
    margin: 0 5px 5px 0;
    cursor: pointer;
    display: flex;
    align-items: center;

    span {
      width: 20px;
      height: 20px;
      min-width: 20px;
      min-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      font-size: 15px;
      font-weight: 700;
      color: #3c2a1e;
      border-radius: 50px;
      margin-left: 10px;
      line-height: 1;
    }
  }

  &:hover {
    .check-selector__list {
      display: block !important;
    }
  }

  &:focus-within {
    .check-selector__list {
      display: block !important;
    }
  }
}
</style>
